const moduleMap = {
	"./react": () => {
		return Promise.resolve().then(() => (() => ((__webpack_require__(533)))));
	},
	"./react-dom": () => {
		return Promise.resolve().then(() => (() => ((__webpack_require__(803)))));
	},
	"./react-router-dom": () => {
		return __webpack_require__.e(643).then(() => (() => ((__webpack_require__(4643)))));
	},
	"./zustand": () => {
		return __webpack_require__.e(352).then(() => (() => ((__webpack_require__(5352)))));
	},
	"./formik": () => {
		return __webpack_require__.e(299).then(() => (() => ((__webpack_require__(7299)))));
	},
	"./yup": () => {
		return __webpack_require__.e(784).then(() => (() => ((__webpack_require__(6784)))));
	},
	"./i18next": () => {
		return Promise.resolve().then(() => (() => ((__webpack_require__(2539)))));
	},
	"./react-i18next": () => {
		return __webpack_require__.e(334).then(() => (() => ((__webpack_require__(1334)))));
	},
	"./styled-components": () => {
		return __webpack_require__.e(555).then(() => (() => ((__webpack_require__(1555)))));
	},
	"./axios": () => {
		return __webpack_require__.e(739).then(() => (() => ((__webpack_require__(4739)))));
	},
	"./react-icons": () => {
		return __webpack_require__.e(327).then(() => (() => ((__webpack_require__(5327)))));
	},
	"./react-hot-toast": () => {
		return __webpack_require__.e(672).then(() => (() => ((__webpack_require__(7672)))));
	},
	"./react-helmet-async": () => {
		return __webpack_require__.e(770).then(() => (() => ((__webpack_require__(1770)))));
	},
	"./@tanstack/react-query": () => {
		return __webpack_require__.e(981).then(() => (() => ((__webpack_require__(5362)))));
	}
};
const get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
const init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	const name = "default"
	const oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});